import { Navigate, Route, Routes } from 'react-router-dom';
import AuthenticatedOutlet from './components/authentication/AuthenticatedOutlet';
import UnauthenticatedOutlet from './components/authentication/UnauthenticatedOutlet';
import NavBar from './components/NavBar';
import EmailValidationPage from './pages/account-management/EmailValidationPage';
import LoginPage from './pages/account-management/LoginPage';
import RegisterPage from './pages/account-management/RegisterPage';
import SettingsPage from './pages/account-management/SettingsPage';
import AddIdeaForPersonPage from './pages/AddIdeaForPersonPage';
import AdminPage from './pages/admin/AdminPage';
import AllProducts from './pages/admin/AllProducts';
import AllUsers from './pages/admin/AllUsers';
import EditIdeaForPersonPage from './pages/EditIdeaForPersonPage';
import EditPersonPage from './pages/EditPersonPage';
import EditWishPage from './pages/EditWishPage';
import HomePage from './pages/HomePage';
import IdeasForPersonPage from './pages/IdeasForPersonPage';
import DataProtectionPage from './pages/legal/DataProtectionPage';
import ImpressumPage from './pages/legal/ImpressumPage';
import TermsAndConditionsPage from './pages/legal/TermsAndConditionsPage';
import MyIdeasPage from './pages/MyIdeasPage';
import MyTagsPage from './pages/MyTagsPage';
import MyWishesPage from './pages/MyWishesPage';
import MyWishPage from './pages/MyWishPage';
import NewWishPage from './pages/NewWishPage';
import SharedWishesPage from './pages/SharedWishesPage';
import SharedWishPage from './pages/SharedWishPage';
import SharedWithMeOverviewPage from './pages/SharedWithMeOverviewPage';
import ShareIdeasPage from './pages/ShareIdeasPage';
import ShareWishesPage from './pages/ShareWishesPage';

function App() {
  return (
    <>
      <NavBar />
      <div className="mt-20">
        <Routes>
          <Route path="impressum" element={<ImpressumPage />} />
          <Route path="datenschutz" element={<DataProtectionPage />} />
          <Route path="agb" element={<TermsAndConditionsPage />} />

          {/* Unauthenticated routes here */}
          <Route path="/login" element={<UnauthenticatedOutlet />}>
            <Route path="" element={<LoginPage />} />
          </Route>
          {/* Authenticated routes here */}
          <Route path="/" element={<AuthenticatedOutlet />}>
            <Route path="email-validation/:token" element={<EmailValidationPage />} />
            <Route path="my-wishes" element={<MyWishesPage />} />
            <Route path="my-wish/:wishId" element={<MyWishPage />} />
            <Route path="share-wishes" element={<ShareWishesPage />} />
            <Route path="new-wish" element={<NewWishPage />} />
            <Route path="edit-wish/:wishId" element={<EditWishPage />} />
            <Route path="ideas" element={<MyIdeasPage />} />
            <Route path="ideas/:personId/:ideaId/edit" element={<EditIdeaForPersonPage />} />
            <Route path="ideas/:personId/edit" element={<EditPersonPage />} />
            <Route path="ideas/:personId/add" element={<AddIdeaForPersonPage />} />
            <Route path="ideas/:personId/share" element={<ShareIdeasPage />} />
            <Route path="ideas/:personId" element={<IdeasForPersonPage />} />
            <Route path="tags" element={<MyTagsPage />} />
            <Route path="shared-with-me" element={<SharedWithMeOverviewPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="admin" element={<AdminPage />}>
              <Route path="all-users" element={<AllUsers />} />
              <Route path="all-wishes" element={<AllProducts />} />
              <Route path="" element={<Navigate to="/admin/all-users" />} />
            </Route>
            <Route path="/" element={<HomePage />} />
          </Route>
          <Route path="shared-wishes/:sharedId" element={<SharedWishesPage />} />
          <Route path="shared-wishes/:sharedId/:wishId" element={<SharedWishPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="register/:sharedId" element={<RegisterPage />} />
          {/* Redirect */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
